import React, { useState } from "react";
import { Actionable, Box, Button, Icon, Popover, SheetContainer, Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import useFormatPrice from "../../../../hooks/useFormatPrice.js";
import { RebookBreakdownList } from "./RebookBreakdownList.js";
import useUserAgent from "../../../../hooks/useUserAgent.js";
import { QuestionMarkCircleIcon } from "@bookingcom/bui-assets-react/streamline";
import { pricingUtils } from "@flights/web-api-utils-universal";
const resetBodyOverflow = () => {
    document.body.style.overflow = "auto";
};
export const RebookCostBreakdown = ({ breakdownOpen, setBreakdownOpen, onCostBreakdownOpen, tripRebookOption, initialOrder, align, rebookFlow }) => {
    const { formatPrice } = useFormatPrice();
    const { isMobile } = useUserAgent();
    const i18n = useI18n();
    const [showPopover, setShowPopover] = useState(false);
    const totalDifferenceForAllPassengers = formatPrice(tripRebookOption.rebookPrice.totalDifference);
    const isNoCostChange = pricingUtils.priceIsZero(tripRebookOption.rebookPrice.totalDifference);
    const handleBreakdownOpen = React.useCallback((status) => {
        if (status && onCostBreakdownOpen) {
            onCostBreakdownOpen();
        }
        setBreakdownOpen(status);
    }, [setBreakdownOpen, onCostBreakdownOpen]);
    const handleInteraction = (e, status) => {
        e.stopPropagation();
        handleBreakdownOpen(status);
        isMobile && resetBodyOverflow();
    };
    const priceBreakDownIcon = isMobile ? (React.createElement(Actionable, { onClick: (e) => {
            handleInteraction(e, true);
        }, attributes: {
            "aria-label": i18n.trans(t("a11y_flights_pb_rebook_cost_breakdown_open_cta"))
        } },
        React.createElement(Box, { padding: 2 },
            React.createElement(Icon, { svg: QuestionMarkCircleIcon })))) : (React.createElement(Popover, { position: "top-start", active: showPopover, onOpen: () => {
            setShowPopover(true);
        }, onClose: () => {
            setShowPopover(false);
        }, closeAriaLabel: i18n.trans(t("a11y_flights_pb_rebook_cost_breakdown_close_cta")) },
        React.createElement(Popover.Trigger, null, (attributes) => (React.createElement(Button, { variant: "tertiary-neutral", size: "medium", attributes: {
                "aria-label": i18n.trans(t("a11y_flights_pb_rebook_cost_breakdown_open_cta")),
                ...attributes
            } },
            React.createElement(Icon, { svg: QuestionMarkCircleIcon })))),
        React.createElement(Popover.Content, null,
            React.createElement(Stack, null,
                React.createElement(Text, { tagName: "h4", variant: "headline_3" }, i18n.trans(t("flights_pb_rebook_cost_breakdown_header"))),
                React.createElement(RebookBreakdownList, { initialOrder: initialOrder, tripRebookOption: tripRebookOption, rebookFlow: rebookFlow })))));
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { gap: 0, direction: "column", alignItems: align },
            React.createElement(Stack, { direction: "row", wrap: "nowrap", gap: 0 },
                React.createElement(Box, { padding: 1 },
                    React.createElement(Text, { variant: "headline_3", tagName: "h3" },
                        "+ ",
                        totalDifferenceForAllPassengers)),
                priceBreakDownIcon),
            React.createElement(Text, { color: "neutral_alt" }, isNoCostChange
                ? i18n.trans(t("flights_pb_rebook_cost_label_no_cost"))
                : i18n.trans(t("flights_pb_rebook_change_cost_label")))),
        isMobile && breakdownOpen && (React.createElement(SheetContainer, { onCloseTrigger: () => setBreakdownOpen(false), title: i18n.trans(t("flights_pb_rebook_cost_breakdown_header")), closeAriaLabel: i18n.trans(t("a11y_flights_pb_rebook_cost_breakdown_close_cta")), active: true },
            React.createElement(RebookBreakdownList, { initialOrder: initialOrder, tripRebookOption: tripRebookOption, rebookFlow: rebookFlow })))));
};
